class SearchFormController {

    constructor($scope, $window, $timeout, configService) {
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.configService = configService;
    }

    $onInit () {
        this.property = this.configService.get('property');
        this.error = null;
        this.searchValue = this.query || '';

        this.setFocusOnFullscreen();
    }

    displaySelect () {
        return !!(this.property.hasTreatments && this.property.hasSpaDays);
    }

    submit () {
        this.error = null;

        if (this.searchValue.length < 3) {
            this.error = 'Your search term must be at least 3 characters long.';
            return;
        }

        this.loading = true;
        this.$window.location = `/search/${this.eventType}?q=${this.searchValue}`;
    }

    close () {
        this.isOpen = undefined;
    }

    setFocusOnFullscreen () {
        if (this.fullscreen === true) {
            this.$timeout(() => {
                let inputEl = this.$window.document.querySelectorAll('.c-search.is-fullscreen .c-input') && this.$window.document.querySelectorAll('.c-search.is-fullscreen .c-input')[0];

                if (inputEl) {
                    this.$scope.$watch(() => this.isOpen, (newVal) => {
                        if (newVal && newVal === true) {
                            inputEl.focus();
                        }
                    });
                }
            });
        }
    }
}

SearchFormController.$inject = ['$scope', '$window', '$timeout', 'configService'];

export default SearchFormController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/controllers/searchForm.controller.js